export default "__VITE_ASSET__C$dRxHOb__"